import React from 'react';
import { config } from './config';
import { H3, Paragraph } from 'scy/text';
import { Section, SubSection, SubSectionItem, insertCity } from './Reasons';
import styles from './styles.mod.scss';

const FAQs = ({ city }) => {
  return (
    <Section title={insertCity(config.faqs.title, city)}>
      <SubSection>
        <SubSectionItems
          items={config.faqs.list_items}
          city={{ code: city.code, name: city.name }}
        />
      </SubSection>
    </Section>
  );
};

const SubSectionItems = ({ items, city }) =>
  items.map(faq => (
    <SubSectionItem key={`faq-${faq.question}-question`}>
      <H3>{insertCity(faq.question, city)}</H3>
      <Paragraph className={styles.paragraph}>
        {insertCity(faq.answer, city)}
      </Paragraph>
    </SubSectionItem>
  ));

export default FAQs;
